import React from "react";

//Constants
import { CUSTOMER_EMAIL } from "../../../constants/constants";

//MUI
import { Container, Typography, useMediaQuery } from "@mui/material";

//Router dom
import { Link } from "react-router-dom";

const TerminosCondicionesComponent = () => {

    const matches = useMediaQuery('(max-width: 950px)')

    return (
        <>
            <Container maxWidth='xl' sx={{ mt: matches ? 5 : 18 }}>
                <Typography
                    variant='h4'
                    sx={{ fontWeight: 'light' }}
                    align='center'>
                    Términos y Condiciones de uso
                </Typography>
                <Typography variant="h6" align="center" sx={{ fontWeight: 'light' }} paragraph>Farmacias Nefrópolis – Tienda en Línea</Typography>
            </Container>

            <Container maxWidth='xl' sx={{ mt: 5 }} className="last-view">
                <Typography variant="body1" paragraph>
                    Bienvenido a SOLUCIONES INTEGRALES BTL S.A. DE C.V., en lo sucesivo “Farmacias Nefrópolis”. Al utilizar nuestra tienda
                    en línea (<a href="https://www.nefropolis.com/tienda">https://www.nefropolis.com/tienda</a>), usted acepta estar sujeto a los presentes Términos y Condiciones, así
                    como a nuestra Política de Privacidad.
                </Typography>
                <Typography variant="h6" gutterBottom>DECLARACIÓN DE DERECHOS Y RESPONSABILIDADES</Typography>
                <Typography variant="body1" paragraph>
                    Esta Declaración de derechos y responsabilidades (en lo sucesivo, “Declaración”, “Condiciones” o “DDR”) tiene su origen
                    en los Principios de “Farmacias Nefrópolis” y contiene las condiciones de servicio que rigen nuestra relación con los
                    usuarios y con todos aquellos que interactúan con “Farmacias Nefrópolis”, así como con las marcas, los productos y los
                    servicios de “Farmacias Nefrópolis”, que se denominan “Productos”, “servicios de Farmacias Nefrópolis” o “servicios”.
                </Typography>
                <Typography variant="h6" gutterBottom>1. ACEPTACIÓN DE LOS TÉRMINOS</Typography>
                <Typography variant="body1">
                    El acceso y uso de nuestro sitio implica su consentimiento a estos Términos y Condiciones. Si no está de acuerdo con
                    ellos, le solicitamos abstenerse de utilizar este sitio o realizar transacciones a través de este.
                </Typography>
                <Typography variant="body1" paragraph>
                    Para utilizar ciertas funcionalidades, el cliente deberá crear una cuenta. Al hacerlo, declara que los datos proporcionados
                    son verdaderos, válidos, legítimos y de su propiedad. La falsedad de estos datos constituye una violación a los presentes
                    términos. El manejo de su cuenta y contraseña es de su entera responsabilidad. Farmacias Nefrópolis no se hace responsable
                    por el uso indebido de la cuenta o del acceso por terceros. El cliente se compromete a mantener la confidencialidad de esta
                    información y a asumir cualquier actividad realizada desde su cuenta.
                </Typography>
                <Typography variant="body1" paragraph>
                    Nos reservamos el derecho de cancelar cuentas o restringir accesos ante cualquier uso indebido, incluyendo, pero no limitado a:
                </Typography>
                <ul>
                    <li><Typography variant="body1">Uso de herramientas automatizadas para extraer información del sitio.</Typography></li>
                    <li><Typography variant="body1">Intentos de modificación o copia del contenido, software o estructura del sitio.</Typography></li>
                    <li><Typography variant="body1">Reproducción, publicación o transmisión de contenido sin autorización.</Typography></li>
                    <li><Typography variant="body1">Acceso no autorizado a cuentas o datos de otros usuarios.</Typography></li>
                    <li><Typography variant="body1">Envío de virus, spam o ataques que afecten el servicio.</Typography></li>
                    <li><Typography variant="body1">Suplantación de identidad o fraude en formas de pago.</Typography></li>
                </ul>
                <Typography variant="body1" paragraph>
                    Farmacias Nefrópolis podrá cooperar con las autoridades correspondientes si se detectan violaciones que deriven en responsabilidades legales
                </Typography>
                <Typography variant="h6" gutterBottom>
                    2. IDENTIDAD DEL PRESTADOR
                </Typography>
                <Typography variant="body1" paragraph>
                    Este sitio es operado por Farmacias Nefrópolis, una empresa mexicana especializada en productos para salud
                    renal, diabetes, hipertensión y bienestar general.
                </Typography>
                <Typography variant="h6" gutterBottom>3. USO DEL SITIO</Typography>
                <Typography variant="body1" paragraph>
                    Usted se compromete a usar este sitio únicamente con fines legales y bajo su propio riesgo. Al crear una cuenta o realizar
                    un pedido, garantiza que la información proporcionada es veraz y actualizada.
                </Typography>
                <Typography variant="body1" paragraph>
                    Al concretar una compra, usted declara que ha leído y acepta plenamente estos términos y condiciones. <br />
                    El proceso de compra incluye:
                </Typography>
                <ul>
                    <li><Typography variant="body1">Selección de productos en el carrito.</Typography></li>
                    <li><Typography variant="body1">Ingreso de datos de contacto y dirección de envío.</Typography></li>
                    <li><Typography variant="body1">Confirmación y pago del pedido.</Typography></li>
                </ul>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }} paragraph>
                    Nos reservamos el derecho de rechazar ventas a:
                </Typography>
                <ul>
                    <li><Typography variant="body1">Usuarios con comportamiento inapropiado hacia nuestro personal o en nuestros canales digitales.</Typography></li>
                    <li><Typography variant="body1">Usuarios con antecedentes de fraude o conductas delictivas.</Typography></li>
                    <li><Typography variant="body1">Usuarios con adeudos pendientes.</Typography></li>
                </ul>
                <Typography variant="h6" gutterBottom>4. INICIO DE SESIÓN CON TERCEROS</Typography>
                <Typography variant="body1" paragraph>
                    Nefrópolis permite a los usuarios registrarse e iniciar sesión mediante servicios de autenticación de terceros como Google y
                    Facebook. Al utilizar estas opciones, el usuario autoriza a Nefrópolis a crear una cuenta con los datos básicos compartidos por
                    dichas plataformas, tales como nombre, correo electrónico y otros necesarios para el funcionamiento del sitio. En caso de que el
                    usuario desee eliminar su cuenta, incluidos sus datos personales (nombre completo, correo electrónico, direcciones guardadas y
                    carritos de compra no finalizados), podrá hacerlo siguiente las siguientes
                    instrucciones: <a href="https://drive.google.com/file/d/1ALOj3HqZ_9-j04VMLcDqHcKJZRAIC1JK/view">Instrucciones eliminación de datos. </a>
                    Para más información sobre el procedimiento de eliminación de datos, el usuario podrá consultar el apartado correspondiente
                    en <a href="https://www.nefropolis.com/mi-cuenta">https://www.nefropolis.com/mi-cuenta</a> o escribir a
                    <a href={`mailto:${CUSTOMER_EMAIL}`}>{CUSTOMER_EMAIL}</a>.
                </Typography>
                <Typography variant="body1" paragraph>
                    Para más información sobre el procedimiento de eliminación de datos, el usuario podrá consultar el apartado correspondiente
                    en <a href="https://www.nefropolis.com/mi-cuenta">https://www.nefropolis.com/mi-cuenta</a> o escribir a
                    <a href={`mailto:${CUSTOMER_EMAIL}`}>{CUSTOMER_EMAIL}</a>.
                </Typography>
                <Typography variant="h6" gutterBottom>5. PRODUCTOS Y DISPONIBILIDAD</Typography>
                <Typography variant="body1" paragraph>
                    Todos los productos ofrecidos están sujetos a disponibilidad. Nos reservamos el derecho de modificar, actualizar o
                    descontinuar productos sin previo aviso. Algunos productos, como medicamentos controlados, pueden requerir receta
                    médica y verificación adicional. Para la venta de medicamentos que de acuerdo con la Legislación aplicable requieran
                    receta médica, al momento de la compra, se deberán llenar los campos establecidos con los datos de la cédula
                    profesional, domicilio y el nombre completo del doctor; además en los casos en los que se indique, se deberá realizar
                    la entrega al repartidor de la receta original correspondiente contra entrega del producto.
                </Typography>
                <ul>
                    <li><Typography variant="body1">Las ventas a través de internet se realizan a reserva de la existencia de los productos.</Typography></li>
                    <li>
                        <Typography variant="body1">
                            Si usted desea adquirir alguno de nuestros productos o servicios puede comunicarse al WhatsApp: (33) 11468502 para conocer
                            las fechas de caducidad de estos. En caso de que haya realizado el pago y no contemos con la existencia, un asesor/a se
                            pondrá en contacto con usted para informarle y darle la fecha en que el producto le será enviado
                        </Typography>
                    </li>
                </ul>
                <Typography variant="h6" gutterBottom>6. PRECIOS Y FORMAS DE PAGO</Typography>
                <Typography variant="body1" paragraph>
                    Todos los precios están expresados en pesos mexicanos (MXN) e incluyen IVA, salvo que se indique lo contrario. Farmacias
                    Nefrópolis se reserva el derecho de modificar los precios en cualquier momento y sin previo aviso. Los precios publicados
                    en la tienda en línea aplican exclusivamente para compras realizadas a través de dicho canal. Los precios pueden variar
                    en las sucursales físicas, dependiendo de la zona geográfica.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }} paragraph>Formas de pago disponibles:</Typography>
                <ul>
                    <li><Typography variant="body1">Pago contra entrega (efectivo).</Typography></li>
                    <li><Typography variant="body1">Tarjeta bancaria.</Typography></li>
                    <li><Typography variant="body1">Transferencia bancaria o métodos de pago electrónicos autorizados.</Typography></li>
                </ul>
                <Typography variant="body1" paragraph>
                    <span style={{ fontWeight: 'bold' }}>Importante:</span> El monto final del pago incluye el precio del producto y el costo de envío correspondiente.
                </Typography>
                <Typography variant="body1" paragraph>
                    Los precios mostrados en nuestras herramientas electrónicas son exclusivos para las compras realizadas en dichas herramientas
                    electrónicas, por lo que nuestros precios en sucursales pueden variar de acuerdo con la zona geográfica.
                </Typography>
                <Typography variant="h6" gutterBottom>7. ENVÍOS Y TIEMPOS DE ENTREGA</Typography>
                <Typography variant="body1" paragraph>
                    Realizamos envíos a toda la República Mexicana, salvo aquellas zonas donde la paquetería no tenga cobertura o se reserve el derecho de entrega.
                </Typography>
                <Typography variant="body1" paragraph>Condiciones de envío:</Typography>
                <ul>
                    <li>
                        <Typography variant="body1">
                            Tiempo estimado de entrega: 48 horas hábiles después de la confirmación de envío (puede variar por zona o contingencias).
                        </Typography>
                    </li>
                    <li><Typography variant="body1">El costo de envío se calcula según el peso del producto y la zona de destino.</Typography></li>
                    <li><Typography variant="body1">Farmacias Nefrópolis utilizará el servicio de paquetería más económico y eficiente disponible.</Typography></li>
                </ul>
                <Typography variant="body1" paragraph>
                    Para dudas sobre su pedido, puede contactarnos al WhatsApp: (33) 11468502 o escribir
                    a <a href={`mailto:${CUSTOMER_EMAIL}`}>{CUSTOMER_EMAIL}</a>. No nos hacemos responsables por retrasos causados
                    por eventos fuera de nuestro control (clima, logística, etc.).
                </Typography>
                <Typography variant="h6" gutterBottom>8. CANCELACIONES Y DEVOLUCIONES</Typography>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }} paragraph>Política general de devoluciones:</Typography>
                <ul>
                    <li><Typography variant="body1">Plazo máximo: <span style={{ fontWeight: 'bold' }}>3 días naturales</span> a partir de la compra.</Typography></li>
                    <li><Typography variant="body1">Es obligatorio presentar el <span style={{ fontWeight: 'bold' }}>ticket original</span>, sin alteraciones.</Typography></li>
                    <li>
                        <Typography variant="body1">
                            La devolución debe realizarse en la <span style={{ fontWeight: 'bold' }}>misma sucursal</span> donde se realizó la compra.
                        </Typography>
                    </li>
                    <li>
                        <Typography variant="body1">
                            El producto debe estar <span style={{ fontWeight: 'bold' }}>completo, sin uso, con su empaque original en buen estado y sellos
                                de seguridad intactos.</span>
                        </Typography>
                    </li>
                </ul>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }} paragraph>Cambios por incidencias de entrega:</Typography>
                <ul>
                    <li>
                        <Typography variant="body1">
                            En caso de que el producto llegue <span style={{ fontWeight: 'bold' }}>derramado, roto o abollado</span>, o
                            si <span style={{ fontWeight: 'bold' }}>no se cumple el tiempode entrega y esto compromete el producto</span>, se podrá solicitar un cambio.
                        </Typography>
                    </li>
                    <li>
                        <Typography variant="body1">
                            El cliente debe <span style={{ fontWeight: 'bold' }}>reportar la incidencia dentro de las 48 horas</span> siguientes a la recepción vía
                            <span style={{ fontWeight: 'bold' }}> WhatsApp al (33) 11468502</span> o al
                            correo <a href={`mailto:${CUSTOMER_EMAIL}`} style={{ fontWeight: 'bold' }}>{CUSTOMER_EMAIL}</a> con evidencia fotográfica.
                        </Typography>
                    </li>
                    <li><Typography variant="body1">El producto deberá ser devuelto en un plazo máximo de <span style={{ fontWeight: 'bold' }}>72 horas.</span></Typography></li>
                </ul>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }} paragraph>Condiciones adicionales: </Typography>
                <ul>
                    <li>
                        <Typography variant="body1">
                            No se realizarán cambios si el producto fue abierto, consumido innecesariamente o en más del <span style={{ fontWeight: 'bold' }}>20%.</span>
                        </Typography>
                    </li>
                    <li><Typography variant="body1">No se realizan <span style={{ fontWeight: 'bold' }}>devoluciones en efectivo.</span></Typography></li>
                    <li><Typography variant="body1">Todo cambio o devolución requiere <span style={{ fontWeight: 'bold' }}>comprobante de pago.</span></Typography></li>
                    <li>
                        <Typography variant="body1">
                            <span style={{ fontWeight: 'bold' }}>El cliente cubre los gastos de envío por devolución</span> en caso de error propio.
                        </Typography>
                    </li>
                    <li>
                        <Typography variant="body1">
                            <span style={{ fontWeight: 'bold' }}>Farmacias Nefrópolis cubre los gastos</span> si el error es atribuible a nosotros.
                        </Typography>
                    </li>
                </ul>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }} gutterBottom>NO EXISTEN DEVOLUCIONES EN: </Typography>
                <ul>
                    <li><Typography variant="body1">Medicamentos abiertos, usados o sin su empaque original.</Typography></li>
                    <li><Typography variant="body1">Medicamentos Psicotrópicos (medicamentos controlados) ni antibióticos.</Typography></li>
                    <li><Typography variant="body1">Refrigerados.</Typography></li>
                    <li><Typography variant="body1">Artículos asociados a promoción con cupón donde expiró su vigencia.</Typography></li>
                    <li><Typography variant="body1">Dulces, productos íntimos y de uso personal y productos perecederos.</Typography></li>
                    <li><Typography variant="body1">Vacunas.</Typography></li>
                </ul>
                <Typography variant="h6" gutterBottom>9. RESPONSABILIDAD MÉDICA </Typography>
                <Typography variant="body1" paragraph>
                    Los productos vendidos en este sitio no sustituyen el diagnóstico, tratamiento o supervisión médica. Recomendamos consultar
                    a su médico antes de consumir cualquier medicamento o suplemento.
                </Typography>
                <Typography variant="h6" gutterBottom>10. PROPIEDAD INTELECTUAL </Typography>
                <Typography variant="body1" paragraph>
                    Todo el contenido del sitio (textos, imágenes, logotipos, diseño) es propiedad de Farmacias Nefrópolis o de sus proveedores y está
                    protegido por la legislación aplicable. Su uso no autorizado está prohibido.
                </Typography>
                <Typography variant="h6" gutterBottom>11. PROTECCIÓN DE DATOS PERSONALES </Typography>
                <Typography variant="body1" paragraph>
                    La información personal proporcionada se tratará conforme a lo establecido en
                    nuestra <Link to='/politica-de-privacidad'>Política de Privacidad</Link>. Nos comprometemos a proteger sus datos de acuerdo con
                    la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
                </Typography>
                <Typography variant="h6" gutterBottom>12. MODIFICACIONES</Typography>
                <Typography variant="body1" paragraph>
                    Farmacias Nefrópolis se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Le recomendamos revisarlos periódicamente.
                </Typography>
                <Typography variant="h6" gutterBottom>13. CONTACTO</Typography>
                <Typography variant="body1" paragraph>
                    Si tiene dudas o desea realizar alguna aclaración, puede comunicarse con nosotros a través de los siguientes canales: <br />
                    Correo: <a href={`mailto:${CUSTOMER_EMAIL}`} style={{ fontWeight: 'bold' }}>{CUSTOMER_EMAIL}</a> <br />
                    WhatsApp: <span style={{ fontWeight: 'bold' }}>(33) 11468502</span> <br />
                    Horario de atención: <span style={{ fontWeight: 'bold' }}>Lunes a viernes de 8:00 a 17:00 hrs.</span>
                </Typography>
            </Container>
        </>
    );
};

export default TerminosCondicionesComponent;